export default {
    "name": "StoreConfigurationPageLoad",
    "kind": "HoudiniQuery",
    "hash": "f749ab4ebcd546abb1782fdc67e70e630c05cf9b4ee7cc63a9c2b1aba0ec99f4",

    "raw": `query StoreConfigurationPageLoad {
  stores {
    id
    address
    city
    code
    country
    fax
    invoiceMemo
    name
    phone
    private
    remittanceAddress
    remittanceCity
    remittanceCountry
    remittancePhone
    remittanceState
    remittanceZip
    state
    webAddress
    zip
    addressService {
      service
      apiKey
    }
    taxService {
      apiKey
      service
    }
  }
  states {
    stateAbbreviation
    stateName
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "stores": {
                "type": "Store",
                "keyRaw": "stores",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "address": {
                            "type": "String",
                            "keyRaw": "address",
                            "visible": true
                        },

                        "city": {
                            "type": "String",
                            "keyRaw": "city",
                            "visible": true
                        },

                        "code": {
                            "type": "String",
                            "keyRaw": "code",
                            "visible": true
                        },

                        "country": {
                            "type": "String",
                            "keyRaw": "country",
                            "visible": true
                        },

                        "fax": {
                            "type": "String",
                            "keyRaw": "fax",
                            "visible": true
                        },

                        "invoiceMemo": {
                            "type": "String",
                            "keyRaw": "invoiceMemo",
                            "nullable": true,
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "phone": {
                            "type": "String",
                            "keyRaw": "phone",
                            "nullable": true,
                            "visible": true
                        },

                        "private": {
                            "type": "Boolean",
                            "keyRaw": "private",
                            "visible": true
                        },

                        "remittanceAddress": {
                            "type": "String",
                            "keyRaw": "remittanceAddress",
                            "nullable": true,
                            "visible": true
                        },

                        "remittanceCity": {
                            "type": "String",
                            "keyRaw": "remittanceCity",
                            "nullable": true,
                            "visible": true
                        },

                        "remittanceCountry": {
                            "type": "String",
                            "keyRaw": "remittanceCountry",
                            "nullable": true,
                            "visible": true
                        },

                        "remittancePhone": {
                            "type": "String",
                            "keyRaw": "remittancePhone",
                            "nullable": true,
                            "visible": true
                        },

                        "remittanceState": {
                            "type": "String",
                            "keyRaw": "remittanceState",
                            "nullable": true,
                            "visible": true
                        },

                        "remittanceZip": {
                            "type": "String",
                            "keyRaw": "remittanceZip",
                            "visible": true
                        },

                        "state": {
                            "type": "String",
                            "keyRaw": "state",
                            "visible": true
                        },

                        "webAddress": {
                            "type": "String",
                            "keyRaw": "webAddress",
                            "nullable": true,
                            "visible": true
                        },

                        "zip": {
                            "type": "String",
                            "keyRaw": "zip",
                            "visible": true
                        },

                        "addressService": {
                            "type": "AddressService",
                            "keyRaw": "addressService",

                            "selection": {
                                "fields": {
                                    "service": {
                                        "type": "AddressServiceEnum",
                                        "keyRaw": "service",
                                        "visible": true
                                    },

                                    "apiKey": {
                                        "type": "String",
                                        "keyRaw": "apiKey",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "taxService": {
                            "type": "TaxService",
                            "keyRaw": "taxService",

                            "selection": {
                                "fields": {
                                    "apiKey": {
                                        "type": "String",
                                        "keyRaw": "apiKey",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "service": {
                                        "type": "TaxServiceEnum",
                                        "keyRaw": "service",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "states": {
                "type": "State",
                "keyRaw": "states",

                "selection": {
                    "fields": {
                        "stateAbbreviation": {
                            "type": "String",
                            "keyRaw": "stateAbbreviation",
                            "nullable": true,
                            "visible": true
                        },

                        "stateName": {
                            "type": "String",
                            "keyRaw": "stateName",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=50027261286fe692e4cf78d6b9013f211c6aad33730f707346a1822cadec443a";